import React from 'react';
import PropTypes from 'prop-types';
import { Breadcrumb, Icon } from 'antd';
import { Link } from 'dva/router';
import pathToRegexp from 'path-to-regexp';
import { queryArray } from 'utils';
import { FormattedMessage } from 'react-intl';

import styles from './Bread.less';

const Bread = ({ menu, companyName = 'Trang chủ' }) => {
  const pathArray = [];
  const current = menu.find(item => item.route && pathToRegexp(item.route).exec(location.pathname));

  const getPathArray = (item) => {
    pathArray.unshift(item);
    if (item.bpid) {
      getPathArray(queryArray(menu, item.bpid, 'id'));
    }
  };

  if (!current) {
    pathArray.push({
      id: 404,
      name: 'Trang không tồn tại',
    });
  } else {
    getPathArray(current);
  }


  const breads = pathArray.map((item, key) => {
    const content = (
      <span>
        {item.icon ? <Icon type={item.icon} style={{ marginRight: 4 }} /> : ''}
        {(typeof (item.name) === 'string' ? item.name : <FormattedMessage {...item.name} />)}
      </span>
    );
    return (
      <Breadcrumb.Item key={key}>
        {
          ((pathArray.length - 1) !== key) ? <Link to={item.route}> {content} </Link> : content
        }
      </Breadcrumb.Item>
    );
  });

  return (
    <div className={styles.bread}>
      <Breadcrumb>
        <Breadcrumb.Item>
          <span className={styles.home}>
            <Icon type="home" style={{ marginRight: 4 }} />
            <Link to="/">{companyName}</Link>
          </span>
        </Breadcrumb.Item>
        {breads}
      </Breadcrumb>
    </div>
  );
};

Bread.propTypes = {
  menu: PropTypes.array,
  companyName: PropTypes.string,
};

export default Bread;



// WEBPACK FOOTER //
// ./src/components/Layout/Bread.js